module.exports = __webpack_public_path__ + "static/media/copy.77986980.svg";